// extracted by css-extract-rspack-plugin
export default {"cls1":"DateFields-cls1_-yI","cls2":"DateFields-cls2__ns DateFields-cls1_-yI"};